import Button from 'react-bootstrap/Button';
// import Tab from 'react-bootstrap/Tab';
// import Tabs from 'react-bootstrap/Tabs';
import EditItem from './EditItem';
import Docs from './Docs';
import Browse from './Browse';
import { useState } from 'react';

function Workspace(props) {
    const [ activeTab, setActiveTab ] = useState('browse');
    const [ selectedItem, setSelectedItem ] = useState(null);

    // scroll to top when switching tabs
    window.scrollTo(0, 0);

    function handleAdd() {
        setActiveTab('add');
    }
    function handleDocs() {
        setActiveTab('docs');
    }
    function handleBrowse() {
        setActiveTab('browse');
    }

    // console.log("activeTab: "+ activeTab + "  selectedItem: "+ selectedItem);

    let content = <>
        <Button variant="primary" onClick={handleAdd}>Add</Button>
        <Button variant="secondary" onClick={handleBrowse}>Browse</Button>
        <Docs />
    </>;

    if (activeTab === 'browse') {
        content = <>
            <Button variant="primary" onClick={handleAdd}>Add</Button>
            <Button variant="secondary" onClick={handleDocs}>Docs</Button>
            <Browse setActiveTab={setActiveTab} setSelectedItem={setSelectedItem} />
        </>;
    }

    if (activeTab === "add") {
        content = <>
            <EditItem setActiveTab={setActiveTab} setSelectedItem={setSelectedItem} itemshortname={selectedItem} />
        </>
    }
    
    return (<>
        {content}
    </>);
}

export default Workspace;